<template>
  <div>
    <div
      id="addClaimItemModal"
      class="modal fade"
      role="dialog"
      aria-labelledby="modelSingle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <!--begin::Form-->
        <form class="kt-form" ref="formItem">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="kt-portlet__body">
                <div class="kt-section kt-section--first">
                  <div
                    v-show="
                      this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'
                    "
                  >
                    <h3 class="kt-section__title">
                      รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ชนิดเครื่อง:</label>
                          <select2
                            id="bciMachineTypeCode"
                            name="bciMachineTypeCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMachineTypeCodeOptions"
                            v-model="bciMachineTypeCode"
                            ref="bciMachineTypeCodeSelect2"
                            @selectChange="onMachineTypeCodeChange"
                            disabled
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >BARCODE (เครื่องเบียร์สด):</label
                          >
                          <input
                            id="bciMachineBarcode"
                            name="bciMachineBarcode"
                            v-model="bciMachineBarcode"
                            type="text"
                            maxlength="20"
                            class="form-control"
                            placeholder="BARCODE (เครื่องเบียร์สด)"
                            @blur="onBlurBarcode(true)"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>ประเภทเครื่องเบียร์สด:</label>
                          <!-- <label class="label-required">ประเภทเครื่องเบียร์สด:</label> -->
                          <select2
                            id="bciMachineCategory"
                            name="bciMachineCategory"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMachineCategoryOptions"
                            v-model="bciMachineCategory"
                            ref="bciMachineCategorySelect2"
                            disabled
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label"
                            >ปริมาณแรงดัน Co2 (PSI./BAR):</label
                          >
                          <input
                            id="bciPressure"
                            name="bciPressure"
                            v-model="bciPressure"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="ปริมาณแรงดัน Co2"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>อุณหภูมิน้ำในเครื่อง (องศาเซลเซียส):</label>
                          <input
                            id="bciTemperature"
                            name="bciTemperature"
                            v-model="bciTemperature"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="อุณหภูมิน้ำในเครื่อง"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันล้างเครื่องล่าสุด:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciPMDate"
                              name="bciPMDate"
                              ref="bciPMDate"
                              disabled
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันที่จัมพ์ถัง:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciJumpDate"
                              name="bciJumpDate"
                              ref="bciJumpDate"
                              disabled
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-show="
                      this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'
                    "
                  >
                    <h3 class="kt-section__title">
                      รายละเอียด การใช้งาน และการบำรุงรักษา:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">มาตรฐานติดตั้ง:</label>
                          <select2
                            id="bciStandardInstallCode"
                            name="bciStandardInstallCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciStandardInstallCodeOptions"
                            v-model="bciStandardInstallCode"
                            ref="bciStandardInstallCodeSelect2"
                            @selectChange="onStandardInstallCodeChange"
                            disabled
                          ></select2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 class="kt-section__title">
                      รายละเอียด สินค้าเบียร์สด:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>แบรนด์สินค้า:</label>
                          <!-- <label class="label-required">แบรนด์สินค้า:</label> -->
                          <input
                            id="bciProductBrand"
                            name="bciProductBrand"
                            v-model="bciProductBrand"
                            type="text"
                            maxlength="450"
                            class="form-control"
                            placeholder="แบรนด์สินค้า"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ชื่อสินค้า:</label>
                          <select2
                            id="bciMaterialCode"
                            name="bciMaterialCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMaterialCodeOptions"
                            v-model="bciMaterialCode"
                            ref="bciMaterialCodeSelect2"
                            @selectChange="onMaterialCodeChange"
                            disabled
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >BARCODE (ถัง):</label
                          >
                          <input
                            id="bciBarcode"
                            name="bciBarcode"
                            v-model="bciBarcode"
                            type="text"
                            maxlength="20"
                            class="form-control"
                            placeholder="BARCODE (ถัง)"
                            @blur="onBlurBarcode(false)"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันผลิตข้างถัง:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciManufacturingDate"
                              name="bciManufacturingDate"
                              ref="bciManufacturingDate"
                              disabled
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>น้ำหนักรวมถัง (กิโลกรัม):</label>
                          <input
                            id="bciWeight"
                            name="bciWeight"
                            v-model="bciWeight"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="น้ำหนักรวมถัง"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">เลขที่ Invoice :</label>
                          <input
                            id="bciInvoice"
                            name="bciInvoice"
                            v-model="bciInvoice"
                            type="text"
                            maxlength="450"
                            class="form-control"
                            placeholder="เลขที่ Invoice"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >วันที่สินค้าเข้าตัวแทนจำหน่าย:</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciAgentReceivedDate"
                              name="bciAgentReceivedDate"
                              ref="bciAgentReceivedDate"
                              disabled
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div
                          class="form-group"
                          v-show="
                            this.$parent.abcClaimTypeCode ==
                              'BEER_CLAIM_TYPE_SHOP'
                          "
                        >
                          <label class="label-required"
                            >วันที่สินค้าเข้าร้านค้า:</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciShopReceivedDate"
                              name="bciShopReceivedDate"
                              ref="bciShopReceivedDate"
                              disabled
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 class="kt-section__title">รายละเอียด ปัญหาที่พบ:</h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ปัญหาที่พบ:</label>
                          <select2
                            id="bciProblemTypeCode"
                            name="bciProblemTypeCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciProblemTypeCodeOptions"
                            v-model="bciProblemTypeCode"
                            ref="bciProblemTypeCodeSelect2"
                            @selectChange="onProblemTypeCodeChange"
                            disabled
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ข้อมูลรูปภาพ:</label>
                          <div class="row">
                            <div class="col-xl-6 col-md-6 col-sm-6">
                              <div class="position-relative">
                                <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed" id="container-img">
                                  <img v-if="uploadFiles[0]" :src="uploadFiles[0].fileURL" @click="showModal(uploadFiles[0].fileURL)" style="object-fit: contain ; width: 100%; height: 100%;">
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-sm-6">
                              <div class="position-relative">
                                <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed" id="container-img2">
                                  <img v-if="uploadFiles[1]" :src="uploadFiles[1].fileURL" @click="showModal(uploadFiles[1].fileURL)" style="object-fit: contain ; width: 100%; height: 100%;">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                              <div class="modal-content mr-4">
                                <div class="modal-header">
                                  <h5 class="modal-title">รูปภาพ</h5>
                                  <button type="button" class="close" aria-label="Close" @click="closeModal">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <img :src="modalImageURL" style="max-width: 90%; max-height: 90%; margin: 0 auto; display: block;">
                                  <button type="button" class="close" aria-label="Close" @click="closeModal">
                                    <h6 class="modal-title"><i class="la la-close"></i> ปิดหน้าต่าง</h6>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <label class="label-required"
                            >รายละเอียดของปัญหา:</label
                          >
                          <textarea
                            placeholder="รายละเอียดของปัญหา"
                            class="form-control"
                            v-model="bciProblemDesc"
                            id="bciProblemDesc"
                            name="bciProblemDesc"
                            rows="5"
                            disabled
                          ></textarea>
                          <span class="form-text"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                <i class="la la-close"></i> ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;
    return {
      uploadFiles: [],
      modalImageURL: '',
      isEdit: false,
      bciProductBrandId: null,
      bciProductBrand: null,
      bciMaterialCode: null,
      bciMaterial: null,
      bciBarcode: null,
      bciManufacturingDate: null,
      bciWeight: 0,
      bciProblemTypeCode: null,
      bciProblemType: null,
      bciProblemDesc: null,
      bciMachineTypeCode: null,
      bciMachineType: null,
      bciMachineBarcode: null,
      bciMachineCategory: null,
      bciPressure: null,
      bciTemperature: null,
      bciPMDate: null,
      bciJumpDate: null,
      bciStandardInstallCode: null,
      bciStandardInstall: null,
      bciAgentReceivedDate: null,
      bciShopReceivedDate: null,
      bciInvoice: null,
      //Options
      bciMachineTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "MACHINE_TYPE",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciStandardInstallCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "STANDARD_INSTALL",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciProblemTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PROBLEM_TYPE",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciMachineCategoryOptions: {
        placeholder: "กรุณาเลือกประเภทเครื่องเบียร์สด",
        allowClear: true,
        data: [
          { id: "false", text: "ไม่มีหัวจ่ายในตัว", data: null },
          { id: "true", text: "มีหัวจ่ายในตัว", data: null },
        ],
      },
      //เฉพาะ หมวดหมู่ สินค้าสำเร็จรูป + ประเภท น้ำเบียร์
      bciMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: "14",
              productTypeId: "22",
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    showModal(imageURL) {
      this.modalImageURL = imageURL;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');
      });
    },
    closeModal() {
      $('#imageModal').modal('hide');
    },
    onMaterialCodeChange: function(id, text, data, ref) {
      var self = this;
      //console.log(data);
      //set product name
      if (data[0] && data[0].text) {
        self.bciMaterial = data[0].text;
      }
      //set brand
      if (data[0] && data[0].data) {
        self.bciProductBrandId = data[0].data.productBrandId;
        self.bciProductBrand = data[0].data.productBrandName;
        //console.log("bciProductBrandId ", self.bciProductBrandId);
      }
    },
    onProblemTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciProblemType = data[0].text;
    },
    onMachineTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciMachineType = data[0].text;
    },
    onStandardInstallCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciStandardInstall = data[0].text;
    },
    onBlurBarcode(isMachine) {
      let self = this;
      // console.log(isMachine);
      // console.log("bciMachineBarcode", self.bciMachineBarcode);
      // console.log("bciBarcode", self.bciBarcode);
      let barcode = isMachine ? self.bciMachineBarcode : self.bciBarcode;
      if (barcode != null) {
        axios
          .post("/Api/BeerClaim/BarcodeData", {
            BarcodeNO: isMachine ? self.bciMachineBarcode : self.bciBarcode,
            IsMachine: isMachine,
          })
          .then(function(response) {
            //console.log("response", response);
            if (response.status == 200) {
              if (isMachine) {
                self.$refs.bciMachineCategorySelect2.setSelectedData({
                  id: response.data.machineCategory + "",
                });
                if (response.data.pmDateFormat) {
                  self.bciPMDate = moment(
                    response.data.pmDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciPMDate).datepicker(
                    "update",
                    response.data.pmDateFormat2
                  );
                }
              } else {
                if (response.data.manufacturingDateFormat) {
                  self.bciManufacturingDate = moment(
                    response.data.manufacturingDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciManufacturingDate).datepicker(
                    "update",
                    response.data.manufacturingDateFormat2
                  );
                }
              }
            } else {
              if (isMachine) {
                self.$refs.bciMachineCategorySelect2.setSelectedData({
                  id: null,
                });
                self.bciPMDate = null;
                $(self.$refs.bciPMDate).datepicker("update", null);
              } else {
                self.bciManufacturingDate = null;
                $(self.$refs.bciManufacturingDate).datepicker("update", null);
              }
            }
          });
      }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.bciManufacturingDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciManufacturingDate)
      .datepicker(
        "update",
        !!self.bciManufacturingDate
          ? self.bciManufacturingDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciManufacturingDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciPMDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciPMDate)
      .datepicker(
        "update",
        !!self.bciPMDate ? self.bciPMDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bciPMDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciJumpDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciJumpDate)
      .datepicker(
        "update",
        !!self.bciJumpDate ? self.bciJumpDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bciJumpDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciAgentReceivedDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciAgentReceivedDate)
      .datepicker(
        "update",
        !!self.bciAgentReceivedDate
          ? self.bciAgentReceivedDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciAgentReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciShopReceivedDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciShopReceivedDate)
      .datepicker(
        "update",
        !!self.bciShopReceivedDate
          ? self.bciShopReceivedDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciShopReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    //#region :: Set Value
    let index = this.$route.params.id;
    //console.log("index ", index);

    if (!index.includes("add_")) {
      let claim = self.$parent.abcClaimItems[index];
      //console.log("claim mounted ", claim);

      //#region :: รายละเอียด สินค้าเบียร์สด
      self.bciProductBrand = claim.productBrand;
      self.bciProductBrandId = claim.productBrandId;

      setTimeout(function() {
        if (claim.materialCode) {
          self.$refs.bciMaterialCodeSelect2.setSelectedData({
            id: claim.materialCode,
            text: claim.material,
          });
        }
      }, 100);

      if (claim.manufacturingDate) {
        let manufacturingDate = moment(claim.manufacturingDate);
        self.bciManufacturingDate = manufacturingDate;
        $(self.$refs.bciManufacturingDate).datepicker(
          "update",
          manufacturingDate.format("DD-MM-YYYY")
        );
      }

      if (claim.agentReceivedDate) {
        let agentReceivedDate = moment(claim.agentReceivedDate);
        self.bciAgentReceivedDate = agentReceivedDate;
        $(self.$refs.bciAgentReceivedDate).datepicker(
          "update",
          agentReceivedDate.format("DD-MM-YYYY")
        );
      }

      if (claim.shopReceivedDate) {
        let shopReceivedDate = moment(claim.shopReceivedDate);
        self.bciShopReceivedDate = shopReceivedDate;
        // console.log("shopReceivedDate ", shopReceivedDate);
        $(self.$refs.bciShopReceivedDate).datepicker(
          "update",
          shopReceivedDate.format("DD-MM-YYYY")
        );
      }

      self.bciBarcode = claim.depCode ? `${claim.barcodeOld}(${claim.depCode})` : claim.barcodeOld;
      self.bciWeight = claim.weight;
      self.bciInvoice = claim.invoice;
      //#endregion :: รายละเอียด สินค้าเบียร์สด

      //#region :: รายละเอียด ปัญหาที่พบ
      if (claim.problemTypeCode) {
        self.$refs.bciProblemTypeCodeSelect2.setSelectedData({
          id: claim.problemTypeCode,
          text: claim.problemType,
        });
      }
      self.bciProblemDesc = claim.problemDesc;
      //#endregion :: รายละเอียด ปัญหาที่พบ

      self.claimItemPicture = claim.claimItemPicture;
      async function loadPictures() {
        for (let i = 0; i < self.claimItemPicture.length; i++) {
          let element = self.claimItemPicture[i];
          self.uploadFiles.push({
            fileURL: element.fileData
          });
        }
      }
      loadPictures();
      //#region :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ
      self.bciMachineBarcode = claim.machineBarcode;
      self.bciPressure = claim.pressure;
      self.bciTemperature = claim.temperature;

      if (claim.machineTypeCode) {
        self.$refs.bciMachineTypeCodeSelect2.setSelectedData({
          id: claim.machineTypeCode,
          text: claim.machineType,
        });
      }

      self.$refs.bciMachineCategorySelect2.setSelectedData({
        id: claim.machineCategory + "",
      });

      if (claim.jumpDate) {
        let jumpDate = moment(claim.jumpDate);
        self.bciJumpDate = jumpDate;
        $(self.$refs.bciJumpDate).datepicker(
          "update",
          jumpDate.format("DD-MM-YYYY")
        );
      }

      if (claim.pmDate) {
        let pmDate = moment(claim.pmDate);
        self.bciPMDate = pmDate;
        $(self.$refs.bciPMDate).datepicker(
          "update",
          pmDate.format("DD-MM-YYYY")
        );
      }
      //#endregion :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ

      //#region :: รายละเอียด การใช้งาน และการบำรุงรักษา
      if (claim.standardInstallCode) {
        self.$refs.bciStandardInstallCodeSelect2.setSelectedData({
          id: claim.standardInstallCode,
          text: claim.standardInstall,
        });
      }
      //#endregion :: รายละเอียด การใช้งาน และการบำรุงรักษา
    }
    //#endregion :: Set Value

    $("#addClaimItemModal")
      .on("hidden.bs.modal", function(e) {
        if (e.target.id && e.target.id == 'addClaimItemModal') {
          router.go(-1);
        }
      })
      .modal("show");
  },
};
</script>

<style lang="scss" scoped>
.border-dashed {
  border: 1px dashed;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/BeerClaimItemDetail.vue